import { TrackerA } from "@/components/Tracker";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import classNames from "classnames";
import styles from "./index.module.less";

export default function MaterialHotSubject({ data, className }) {
  const displayWidth =
    (1296 - 24 * (data?.list?.length - 1)) / data?.list?.length;

  return (
    <div className={classNames([styles.subject, className])}>
      {/* <div className={styles.header}>
        <div className={styles.title}>{data?.name}</div>
      </div> */}
      <div className={styles.list}>
        {data?.list?.map((item) => (
          // eslint-disable-next-line react/jsx-no-target-blank
          <TrackerA
            className={styles.card}
            key={item?.id}
            href={item?.link}
            target="_blank"
            rel={`${item?.link.includes("/utms/") ? "nofollow" : ""}`}
            data-gd-click="topic_click"
            data-gd-expose="topic_expose"
            data-topic-type="一级主题"
            data-topic-id={item?.id}
            data-topic-title={item?.trackerTitle}
            data-content-source={data?.name}
          >
            <div className={styles.img}>
              <img
                {...gdImgSrcPolicy(item?.banner_img_url, {
                  displayWidth,
                  type: null,
                })}
                alt={item?.title}
              />
            </div>
            {/* <div className={styles.content}>
              <div className={styles.title}>{item?.title}</div>
              <div className={styles.subtitle}>{item?.description}</div>
            </div> */}
          </TrackerA>
        ))}
      </div>
    </div>
  );
}
